import React from 'react';

/*
 * Lazy, CLS-safe image — a drop-in replacement for the old background-image
 * divs. Renders a real <img> so it can be natively lazy-loaded (defers
 * off-screen loads on long product grids — a real win on the high-latency
 * Greece->Hetzner path) and is accessible. Sizing comes from the className
 * (the element keeps its old fixed-size class); object-fit:cover reproduces
 * the previous background-size:cover crop.
 *
 * Pass eager (e.g. above-the-fold hero) to opt out of lazy loading.
 */
const Img = ({ src, alt = '', className = '', eager = false, objectFit = 'cover', onClick, style, ...rest }) => (
  <img
    className={className}
    src={src}
    alt={alt}
    loading={eager ? 'eager' : 'lazy'}
    decoding="async"
    onClick={onClick}
    style={{ objectFit, display: 'block', ...style }}
    {...rest}
  />
);

export default Img;
